// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app___B2LQ"};